<template>
  <ExpiredVoucher v-if="status === VOUCHER_STATUS.EXPIRED" :amount="amount" />
  <ValidVoucher v-else-if="status === VOUCHER_STATUS.VALID" :amount="amount" :expireDate="expireDate" />
  <IrredeemableVoucher v-else-if="status === VOUCHER_STATUS.IRREDEEMABLE" :amount="amount" />
  <RedeemedVoucher v-else-if="status === VOUCHER_STATUS.REDEEMED" />
  <InvalidVoucher v-else-if="status === VOUCHER_STATUS.INVALID" />
  <RejectedVoucher v-else-if="status === VOUCHER_STATUS.REJECTED" />
  <NotApplicableVoucher v-else />
</template>

<script>
import RedeemedVoucher from './RedeemedVoucher.vue';
import NotApplicableVoucher from './NotApplicableVoucher.vue';
import ExpiredVoucher from './ExpiredVoucher.vue';
import IrredeemableVoucher from './IrredeemableVoucher.vue';
import ValidVoucher from './ValidVoucher.vue';
import InvalidVoucher from './InvalidVoucher.vue';
import RejectedVoucher from './RejectedVoucher.vue';
import { STATUS as VOUCHER_STATUS } from '../constants/voucher';

export default {
  name: 'VoucherContainer',
  props: ['id', 'expireDate', 'status', 'amount'],
  data() {
    return {
      VOUCHER_STATUS
    };
  },
  components: {
    RedeemedVoucher,
    NotApplicableVoucher,
    ExpiredVoucher,
    IrredeemableVoucher,
    ValidVoucher,
    InvalidVoucher,
    RejectedVoucher
  }
};
</script>
